module.exports = __webpack_public_path__ + "img/block-768.56e06058.jpg";